import React from 'react';

const LoadingSpinner = () => {
  return <div className="w-6 h-6 border-t-4 border-blue-500 border-solid rounded-full animate-spin"></div>;
};

export default LoadingSpinner;
